import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './views/Home';
import ProductDetail from './views/ProductDetail';
import SobreHuelmu from './views/SobreHuelmu';
import Newsletter from './views/Newsletter';
import Contacto from './views/Contacto';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sobre-huelmu" element={<SobreHuelmu />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/products/:id" element={<ProductDetail />} />
      </Routes>
    </Router>
  );
}

export default App;